import axios, { AxiosResponse } from 'axios'
import qs from 'qs'
import { Person, ResourceTypes, SingleResourceResponse } from '@vendorflow/types'

import { AZIMUTH_API_URL, VERSION } from 'constants/Api.constants'
import { AUTHORIZATION_SENTINEL } from 'features/auth/Auth.constants'

export async function fetchWhoAmIUsingGET(): Promise<SingleResourceResponse<Person, ResourceTypes.PEOPLE>> {
  const response: AxiosResponse<SingleResourceResponse<Person, ResourceTypes.PEOPLE>> = await axios.request({
    method: 'GET',
    url: `${AZIMUTH_API_URL}/${VERSION}/auth/whoami`,
    headers: { Authorization: AUTHORIZATION_SENTINEL },
  })

  return response.data
}

export async function fetchFirebaseToken(bobId: string): Promise<string> {
  const queryString = qs.stringify({ identity: bobId })
  const response: AxiosResponse<{ firebaseToken: string }> = await axios.request({
    method: 'GET',
    url: `${AZIMUTH_API_URL}/firebase/token?${queryString}`,
    headers: { Authorization: AUTHORIZATION_SENTINEL },
  })

  return response.data.firebaseToken
}
